import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomDropDownListOptions } from 'src/app/core/custom-drop-down-list/customDropDownList.interface';
import { CustomMultiSelectOptions } from 'src/app/core/custom-multi-select/custom-multi-selec.interface';
import { CustomSwitchOptions } from 'src/app/core/custom-switch/custom-switch.interface';
import { DynamicFormComponent } from 'src/app/core/dynamic-form/dynamic-form.component';
import { DynamicFormOptions, FieldConfig } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { BrowserDetectorService } from 'src/app/services/browser-detector.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FieldTypeEnum } from 'src/app/core/dynamic-form/dynamicForm.interface';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TestModule } from './test.module';
import { MultiSelectComponent } from '@syncfusion/ej2-angular-dropdowns';
import { MasterdataService } from '../masterdata/masterdata.service';
import { environment } from 'src/environments/environment';
import { DropdownServiceService } from 'src/app/services/dropdown-service.service';
import { arraysAreNotAllowedInProps } from '@ngrx/store/src/models';
import { BaseResponse } from 'src/app/model/response/base-response';
import { GenericDD } from 'src/app/model/generic-data';
import { Subject, takeUntil } from 'rxjs';
import { IdbService } from 'src/app/services/idb.service';



export interface testModel {
  id: number,
  name: string,
  description: string,
  dateStart: string,
  dateEnd: string,
}

@Component({
  selector: 'app-test',
  templateUrl: './test.component.html',
  styleUrls: ['./test.component.scss'],
  providers: [
    DatePipe,
  ],
})
export class TestComponent implements OnInit, OnDestroy {


  @ViewChild('myForm') myForm!: DynamicFormComponent;
  @ViewChild('multiss') myMulti !: MultiSelectComponent;


  // unsubscribe subscriptions
  private theEnd$ = new Subject<void>();

  dialog:any;

  ready:boolean= true;


  currentDate: string | null;

  dynamicFormOptions: DynamicFormOptions = {
    size: 'grid-cols-2',
    nrColWidth: 6
  };

  form2Opts: DynamicFormOptions = {
    size: 'grid-cols-2',
    nrColWidth: 2
  };

  regConfig2: FieldConfig[] = [];

  customSwitchOptions: CustomSwitchOptions = {

  };

  regConfig5: FieldConfig[] = [];

  regConfig3: FieldConfig[] = [];
  formOptions3: DynamicFormOptions = {
    size: 'grid-cols-3',
    nrColWidth: 3,
  }

  regConfig: FieldConfig[] = [];

  customDropDownOptions: CustomDropDownListOptions = {

    fields: { text: 'descrizione', value: 'ID', groupBy: 'groupByProperty' },
    placeholder: 'place holder..',
    readonly: false,
    allowFiltering: true,
    value: 'Tennis'
  }

  multiOptions: CustomMultiSelectOptions = {
    fields: { text: 'descrizione', value: 'ID', groupBy: 'groupByProperty' },
    placeholder: 'place holder..',
    readonly: false,
    allowFiltering: true,
    //value: ['snooker'],
  }

  normalForm = new FormGroup({
    date: new FormControl<string>('', Validators.nullValidator),
    name: new FormControl<string>('', Validators.nullValidator),
  });

  TokyoRomaBerlino: Array<any> = [
    { ID: 'Giappone', descrizione: 'Giappone', groupByProperty:'Tokyo' },
    { ID: 'Italia', descrizione: 'Italia',groupByProperty:'Roma' },
    { ID: 'Germania', descrizione: 'Germania',groupByProperty:'Berlino' },
  ];

  TRBOptionsMulti : CustomMultiSelectOptions = {
    fields: { text: 'codice', value: 'id', groupBy: 'groupByProperty',  },
    placeholder: 'Seleziona una città...',
    readonly: false,
    allowFiltering: true,
    url: `province/all`,
  };

  constructor(private browser: BrowserDetectorService,
    private localStorage: LocalStorageService,
    private ddService : DropdownServiceService,
    private idb: IdbService,
    private router: Router,
    private datePipe: DatePipe,
    private http: HttpClient,
    private mds: MasterdataService,
    ) {
      this.currentDate = this.datePipe.transform(new Date(), 'dd-MM-YYYY');
      this.localStorage.setTitolo('CSS DOC')
  }

  addComuniTest(){

  }

  ngOnInit(): void {

    //this.idb.fetchData();
    setTimeout( () => {
      this.myMulti.value = ['Giappone'];
    }, 3000);

    //setTimeout(() => {
      // creo terzo form
      this.regConfig3 = [
        // {
        //   type: FieldTypeEnum.switch,
        //   label: 'Sei un bro?',
        //   name: 'bro',
        //   isRequired:true,
        //   validations: [
        //     {
        //       name: 'required',
        //       validator: Validators.required,
        //       message: 'Perfavore rispondi',
        //     },
        //   ],
        // },
        {
          type: FieldTypeEnum.multiLazy,
          label: 'Multi',
          name: 'multi',
          isRequired: false,
          data: this.TokyoRomaBerlino,
          options: this.TRBOptionsMulti,
          value: [
            'Giappone',
          ],
        },
        // {
        //   type: FieldTypeEnum.input,
        //   name: 'broName',
        //   label: 'Come ti chiami bro?',
        //   isRequired:true,
        //   validations: [
        //     {
        //       name: 'required',
        //       validator: Validators.required,
        //       message: 'Perfavore dimmi il tuo nome',
        //     },
        //   ],
        //   value: 'Manjo was also here :P',
        //   cssClass: 'e-input transform duration-300',
        // },
        // {
        //   type: FieldTypeEnum.date,
        //   label: 'Seleziona la data di inizio',
        //   placeholder: 'useless here',
        //   name: 'datePick',
        //   //value: this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm'),
        // },
        // {
        //   type: FieldTypeEnum.dateTime,
        //   label: 'Seleziona la data di fine',
        //   placeholder: 'useless here',
        //   name: 'datePick2',
        //   //value: new Date(),
        // },
        {
          name: 'Invia',
          type: FieldTypeEnum.button,
          label: 'btn',
          buttonType: 'submit',
          isDisabled: false,
          cssClass: 'e-danger my-2 rounded-lg'
        }
      ];
    //}, 5000);*/

    setTimeout(() => {
      this.regConfig3[1].value = ['Giappone'];
    }, 4000);

    this.localStorage.setTitolo('TEST')
    this.regConfig = [
      {
        type: FieldTypeEnum.select,
        label: 'Sport',
        placeholder: 'Seleziona nazione',
        name: 'sport',
        options: this.customDropDownOptions,
        data: [
          { ID: 'tennis', descrizione: 'Tennis', groupByProperty:'pippo' },
          { ID: 'snooker', descrizione: 'Snooker',groupByProperty:'pippo' },
          { ID: 'cricket', descrizione: 'Cricket',groupByProperty:'pluto' },
        ],
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Nazione richiesta',
          },
        ],
      },

      {
        name: 'bottone',
        type: FieldTypeEnum.button,
        label: 'Bottone',
        buttonType: 'submit',
        isDisabled: false,
      },
    ];

    this.regConfig2 = [
      {
        type: FieldTypeEnum.switch,
        label: 'Sei un bro?',
        name: 'bro',
        isRequired:true,
        autoFocus: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Perfavore rispondi',
          },
        ],
      },
      {
        type: FieldTypeEnum.checkbox,
        label: 'Accetti?',
        name: 'broReal',
        //autoFocus: true,
      },
      {
        type: FieldTypeEnum.input,
        name: 'broName',
        label: 'Come ti chiami bro?',
        isRequired:true,
        //autoFocus: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Perfavore dimmi il tuo nome',
          }
        ],
        cssClass: 'e-input transform duration-300',
      },
      {
        type: FieldTypeEnum.input,
        name: 'broSurName',
        label: 'Cognome ?',
        isRequired:true,
        //autoFocus: true,
        validations: [

        ],
        cssClass: 'e-input transform duration-300',
      },
      {
        type: FieldTypeEnum.multi,
        label: 'Che sport fai ?',
        placeholder: 'Seleziona sport',
        name: 'sportBro',
        //autoFocus: true,
        options: this.multiOptions,
        data: [
          { ID: 'tennis', descrizione: 'Tennis', groupByProperty:'pippo' },
          { ID: 'snooker', descrizione: 'Snooker',groupByProperty:'pippo' },
          { ID: 'cricket', descrizione: 'Cricket',groupByProperty:'pluto' },
        ],
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Sport richiesto',
          },
        ],
        value: ['snooker'],
      },
      {
        type: FieldTypeEnum.select,
        label: 'nazioneBro',
        placeholder: 'Seleziona nazione',
        name: 'asse',
        options: this.customDropDownOptions,
        //autoFocus: true,
        data: [
          { ID: 'Giappone', descrizione: 'Giappone', groupByProperty:'Tokyo' },
          { ID: 'Italia', descrizione: 'Italia',groupByProperty:'Roma' },
          { ID: 'Germania', descrizione: 'Germania',groupByProperty:'Berlino' },
        ],
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Nazione richiesta',
          },
        ],
        //value: ['Giappone'],
      },
      {
        type: FieldTypeEnum.date,
        label: 'Seleziona la data di inizio',
        placeholder: 'useless here',
        name: 'datePick',
        autoFocus: true,
        value: this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm'),
      },
      {
        type: FieldTypeEnum.dateTime,
        label: 'Seleziona la data di fine',
        placeholder: 'useless here',
        name: 'datePick2',
        //autoFocus: true,
        value: new Date(),
      },
      {
        type: FieldTypeEnum.textarea,
        label: 'Raccontami qualcosa',
        placeholder: 'Scrivi qualcosa',
        name: 'textarea',
        autoFocus: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Devi dirmi qualcosa',
          },
        ],
      },
      /*{
        type: FieldTypeEnum.fake,
        name: 'fake',
      },*/
      {
        type: FieldTypeEnum.divider,
        name: 'divider',
      },
      {
        type: FieldTypeEnum.divider,
        name: 'divider',
      },
      {
        name: 'Invia',
        type: FieldTypeEnum.button,
        label: 'btn',
        buttonType: 'submit',
        isDisabled: false,
        //autoFocus: true,
        cssClass: 'e-danger my-2 rounded-lg'
      },
      {
        name: 'Implode',
        type: FieldTypeEnum.button,
        label: 'btn222',
        buttonType: 'normal',
        isDisabled: false,
        autoFocus: false,
        cssClass: 'e-success my-2 rounded-lg'
      }
    ];


  }


  ngOnDestroy(): void {    
    this.theEnd$.unsubscribe();
  }

  filterMulti(e:any){
    console.log(e)
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.regConfig = [
        {
          type: FieldTypeEnum.select,
          label: 'Sport',
          placeholder: 'Seleziona nazione',
          name: 'sport',
          multiple: false,
          options:this.customDropDownOptions,
          data: [
            { ID: 'tennis', descrizione: 'Tennis' },
            { ID: 'snooker', descrizione: 'Snooker' },
            { ID: 'cricket', descrizione: 'Cricket' },
            { ID: 'football', descrizione: 'Football' },
            { ID: 'rugby', descrizione: 'Rugby' },
          ]
          ,
          validations: [
            {
              name: 'required',
              validator: Validators.required,
              message: 'Nazione richiesta',
            },
          ],
        },
        {
          type: FieldTypeEnum.button,
          name:'bottone',
          label: 'Bottone',
          buttonType: 'submit',
          isDisabled: false,
        },
      ];

      //console.log(this.myForm.value);
      this.normalForm.setValue({
        date: this.datePipe.transform(new Date(), 'yyyy-MM-ddTHH:mm'),
        name: 'Manjo was here :P',
      });
      this.currentDate = this.datePipe.transform(new Date(), 'YYYY/MM/ddTHH:mm');



    }, 10000);

  }

  submit(event: any) {
    // let data:GenericDD[] = [];
    // event.multi.forEach((element: any) => {
    //   console.log(element)
    //   let value :GenericDD = {
    //     id:element,
    //     codice: element
    //   }
    //   data.push(value)
    // });
    // this.dds.AddComuniTest(data).subscribe({
    //   next:(response:BaseResponse)=>{
    //     console.log(response)
    //   }
    // })
    // console.log(event);
  }

  onFormChange(event: any) {
    console.log(event);
  }

  onFieldChange(event: any) {
    console.log(event);
  }

  submit2(event:any) {
    console.log(event);
    let obj: testModel = {
      id: 0,
      name: event.broName,
      description: event.textarea,
      dateStart: event.datePick,
      dateEnd: event.datePick2,
    }
    this.http.post<any>("https://localhost:7142/api/test/date/time", obj).subscribe({
      next: (risp: testModel) => {
        console.log("parsed data to backend ");
        console.log(risp);
      },
      error: () => {
        console.error("Date dont work!!!");
      }
    });
  }

  switchChange(event:any) {
    console.warn("Switch value changed");
    console.log(event);
  }

  checkbocChange(event:any) {
    console.log("check boc value changed");
    console.log(event);
  }


  deleteInit(): void {
    this.dialog = DialogUtility.confirm({
      title: 'Conferma rimozione',
      content: 'Stai per eliminare questo cliente, vuoi procedere?',
      width: '50vh',
      position: { X: 'center', Y: 'center' },
      okButton: { click: this.deleteDialog.bind(this), text: 'si', cssClass: 'e-primary dialog-button' },
      cancelButton: { text: 'no' },
    });
  }

  deleteDialog() {
    this.dialog.hide();
  }

  sendNormalDataForm() {
    console.log(this.normalForm.value);
  }

}
